module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAAb1BMVEUAAADBxc3Ly9bBxczBxczBxs3Cxs7Cxs3X19f////Bxc3AxM3Bxc3Bxc3Bxc3BxM3Bxc3Bxs7Cxs3Cxs7Axc7Ex9HBxc3Bxc3Bxc3Cxs3Cxc7ByM/BxMzBxMzBxczCxM3Cxc3Dxs7Fxcz////Bxc1mXAhEAAAAJHRSTlMA+Q7y0phtZgcC5sWxpZ6UglNMQDob6tipekkl3t3LdVxZIwTXmuH/AAAAj0lEQVQY012MVxLDIBBDvVQXCATcnZ69/xlDCcwk+pBG4rFN0MEvMKu9KZLQrxtnqNvcz6hJTAGn1EkfM7/4GHYm5a+6RWcBqMgUnIo6HDgGB1mHKQ0Lr4PDeM5c2zLwJXHUfvuIj5QC7l1M39PMdgaHzYkVB6remd0HRGCy86ADm0ReiXZgml890f4tkn0A7ikG39jeJfsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/sousuo-2.png
// module id = 3
// module chunks = 1